import React from "react";
import Header from '../header'
import { connect } from "react-redux";
import { compose } from "recompose";
import Popup from "../popup";
import ManagePaymentMethod from "../popup/managePaymentMethod"
import config from "../../config"
import Intercom from 'react-intercom';
import  "./style.scss";
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css';
import { getCookie } from "../../helpers/utility"


const mapDispatchToProps = ({ verification, payment }) => {
    return {
        ...verification,
        ...payment
    };
};
const mapStateToProps = ({ verification, payment }) => {
    return {
        ...verification,
        ...payment
    };
};
export class Layout extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            menuOpen: true,
            modalOpen: false,
            paymentMethodModal: false,
            newPaymentModal: false,
            showIntercom:false,
            cardsLoading:false,
            loginType:"",
        }
    }
    logout() {
        this.props.clearAlldata()
        this.props.logout()
    }

    handlePaymentMethodModal() {
        this.setState({ modalOpen: true })
    }
    closeModal() {
        this.setState({ modalOpen: false })
    }
    async getAllCard() {
        let userToken = getCookie()
        if(userToken && userToken.user && userToken.user.cardConnectId){
            this.setState({cardsLoading:true})
            await this.props.getAllCards()
            this.setState({cardsLoading:false})
        }
    }
    async getAllStripeCard() {
        if(this.props.isSaveCardConf && this.props.platform_stripe_customer_id){
            let payload = {}
            payload[0] = this.props.platform_stripe_customer_id
            this.setState({cardsLoading:true})
            await this.props.getAllStripeCards(payload)
            this.setState({cardsLoading:false})
        }
    }
    async addCard(data) {
        let res = await this.props.addCard(data)
        if (res) {
            if(this.props.userData && this.props.userData.user && this.props.userData.user.cardConnectId ){
                this.getAllCard()
            }
        }
    }
    async removeCard(data){
        if(data && data.acctid){
            let res = await this.props.removeCard(data)
            if (res) {
                this.getAllCard()
                return res
            }
        }  
    }
    async removeStripeCard(data){
        if(data && data.paymentMethod){
            let payload = {}
            payload[0] = this.props.platform_stripe_customer_id
            payload[1] = data.paymentMethod
            let res = await this.props.removeStripeCard(payload)
            if (res) {
                this.getAllStripeCard()
                return res
            }
        }
    }
    async handleEditCardconnectCard(payload){
        await this.props.handleEditCardconnectCard(payload)
        await this.props.getAllCards()
    }
    async handleChat(){

       await this.setState({showIntercom:true})
       if (window.Intercom) {
        window.Intercom('show')
       }
    }
    async init(){
    //    if(this.props.userData && this.props.userData.user){
    //        await this.props.getMe()
    //    }
       let token = getCookie()
       if(token && token.loginType){
           this.setState({loginType:token.loginType})
       }
    }
    componentDidMount(){
        this.init()
    }
    render() {
        const { children, settings } = this.props
        return (
            <div>
                 <ReactNotification/>
                {
                    !settings.hideHeader ?
                        <Header backTositeUrl={this.props.backTositeUrl}  handleChat={this.handleChat.bind(this)} paymentMethod={this.handlePaymentMethodModal.bind(this)} logout={this.logout.bind(this)} user={this.props.userData} loginType={this.state.loginType} />
                        : null
                }
                    <main className="main">
                        {children}
                    </main>
                    {this.state.modalOpen &&
                        <Popup close={this.closeModal.bind(this)}>
                            {this.props.businessPaymentType === 'stripe'?
                            <ManagePaymentMethod 
                                cardsList={this.props.cardsList} 
                                handleAddCard={this.addCard.bind(this)}
                                removeCard={this.removeStripeCard.bind(this)}
                                getAllCard={this.getAllStripeCard.bind(this)}
                                businessPaymentType = {this.props.businessPaymentType}
                                handleEditCardconnectCard={this.handleEditCardconnectCard.bind(this)}
                                loading={this.props.paymentLoading}
                                user={this.props.userData}
                                cardsLoading={this.state.cardsLoading}
                                />
                            :
                            <ManagePaymentMethod 
                                cardsList={this.props.cardsList} 
                                handleAddCard={this.addCard.bind(this)}
                                removeCard={this.removeCard.bind(this)}
                                getAllCard={this.getAllCard.bind(this)}
                                businessPaymentType = {this.props.businessPaymentType}
                                handleEditCardconnectCard={this.handleEditCardconnectCard.bind(this)}
                                loading={this.props.paymentLoading}
                                user={this.props.userData}
                                cardsLoading={this.state.cardsLoading}
                                />
                            }
                        </Popup>
                    }
                 {this.state.showIntercom ?   
                <Intercom appID={config.intercom} { ...this.props.userData } /> : null }

            </div>
        )
    }
}
export default compose(connect(mapStateToProps, mapDispatchToProps))(Layout);
